import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { CreateUserAccountParameter, getCreateUserAccount } from "@TKCCP/Services/tkccpCreateUserAccountService";
import { getCustomerAttributeList } from "@TKCCP/Services/tkccpCustomerRegistrationService";
import { CustomerAttributeModel } from "@TKCCP/Types/ApiModels";

type CustomerAttributeParameter = 
    HasOnSuccess<CustomerAttributeModel>;

type HandlerType = ApiHandler<CustomerAttributeParameter, CustomerAttributeModel>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getCustomerAttributeList();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);

    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const loadCustomerAttribute = createHandlerChainRunner(chain, "LoadCustomerAttribute");
export default loadCustomerAttribute;
